import React, { useEffect } from "react";
import FeelingProud from "./FeelingProud";
import SittingRight from "./SittingRight";
import "./MainHeading.css";

const MainHeading = (props) => {
  console.log(props);
  useEffect(() => {
    document.title = "OKR Cheat Sheet | Mesh";
  }, []);
  return (
    <div className="main-heading">
      <SittingRight />
      <h1 className="main-heading-text">
        {props.heading}
        <br />
        {props.heading2}
      </h1>
      <FeelingProud />
    </div>
  );
};

export default MainHeading;
